import React from 'react';
import ErrorBoundary from './components/ErrorBoundary';
import Routes from './Routes';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProfileProvider } from './contexts/LanguageProfileContext';
import { ModalProvider } from './components/ui/ModalProvider';



function App() {
  return (
    <AuthProvider>
      <LanguageProfileProvider>
        <ModalProvider>
          <ErrorBoundary>
            <Routes />
          </ErrorBoundary>
        </ModalProvider>
      </LanguageProfileProvider>
    </AuthProvider>
  );
}

export default App;